export const theme = {
  colors: {
    // Primary Brand Colors (Extracted from Logo Ring)
    primary: '#0F8B42',        // Vibrant Green (Outer circular frame)
    primaryHover: '#0B6E34',   // Darker Green for hover states
    primaryLight: '#E8F5EE',   // Very Light Tinted Green background

    // Secondary / Accent Colors (Extracted from JS Monogram & Text)
    secondary: '#0083B8',      // Cerulean / Ocean Blue (JS emblem & English/Arabic typography)
    secondaryHover: '#006691', // Darker Blue for hover states
    secondaryLight: '#E5F4FA', // Very Light Tinted Blue background
    
    // Text Colors
    textDark: '#1E293B',       // Deep Slate for general readability
    textMuted: '#64748B',      // Warm Slate Grey
    textLight: '#F8FAFC',      // Off-White
    
    // Background Colors
    bgLight: '#FAF9F6',        // Clean Warm Off-White
    bgAccent: '#F1F5F9',       // Light Concrete Grey
    bgDark: '#0F172A',         // Slate Black
    
    // UI Elements
    border: '#E2E8F0',
    white: '#FFFFFF',
  },
  fonts: {
    english: "'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    arabic: "'Cairo', 'Tajawal', sans-serif",
  },
  breakpoints: {
    mobile: '576px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px',
  },
  shadows: {
    sm: '0 1px 3px rgba(0,0,0,0.05)',
    md: '0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -1px rgba(0,0,0,0.04)',
    lg: '0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -2px rgba(0,0,0,0.05)',
  },
  transitions: {
    default: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  }
};